import React from 'react';

interface ButtonProps extends React.ButtonHTMLAttributes<HTMLButtonElement> {
  className?: string;
  type?: 'button' | 'submit' | 'reset';
  label?: string;
  buttonIcon?: React.ReactNode;
  buttonIconPosition?: 'left' | 'right';
  disabled?: boolean;
}

export const Button: React.FC<ButtonProps> = ({
  className = '',
  type = 'button',
  label,
  buttonIcon,
  buttonIconPosition,
  disabled,
  ...otherProps
}) => {
  return (
    <button
      type={type}
      className={['mz-btn', className].join(' ')}
      disabled={disabled}
      {...otherProps}
    >
      {buttonIcon && buttonIconPosition === 'left' && buttonIcon}
      <span>{label}</span>
      {buttonIcon && buttonIconPosition === 'right' && buttonIcon}
    </button>
  );
};

export default Button;
